/**
 * KAN-870: плашка "Доступна новая версия" с кнопкой "Обновить".
 * Ничего не рисует, пока новой версии на сервере нет.
 */
import { RefreshCw } from 'lucide-react';
import { useAppUpdate } from '@/hooks/useAppUpdate';

export function AppUpdateBanner(): JSX.Element | null {
  const { updateAvailable, reload } = useAppUpdate();
  if (!updateAvailable) return null;
  return (
    <div
      role="status"
      data-testid="app-update-banner"
      className="flex items-center justify-between gap-3 bg-blue-600 px-4 py-2 text-sm text-white"
    >
      <span className="flex items-center gap-2">
        <RefreshCw className="h-4 w-4 shrink-0" aria-hidden="true" />
        Доступна новая версия
      </span>
      <button
        type="button"
        onClick={reload}
        className="h-9 shrink-0 rounded-md bg-white px-4 font-medium text-blue-700 hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-blue-600"
      >
        Обновить
      </button>
    </div>
  );
}
